import { VideoModal } from '../components/video_modal.js';

export class PageHome extends DrupalBehavior {
  onReady(document) {
    function ctaGrid() {
      var title = document.querySelector('.icon-cards--title');
      var items = document.querySelectorAll('.icon-card');

      ctaGridTimeline
        .from(
          title,
          { duration: 1, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0
        )
        .from(
          items,
          {
            duration: 1,
            ease: 'power4.out',
            yPercent: 25,
            opacity: 0,
            stagger: 0.125,
          },
          0.125
        );

      ctaGridTimeline.progress(1).progress(0);

      io.observe(ctaGridTarget);
    }

    function mobileBanner() {
      var imageWrap = document.querySelector('.mobile-banner--image--wrap');
      var body = document.querySelector('.mobile-banner--body');

      mobileBannerTimeline
        .from(
          imageWrap,
          { duration: 1, ease: 'power4.out', yPercent: 25, opacity: 0 },
          0
        )
        .from(
          body,
          { duration: 1, ease: 'power4.out', yPercent: 25, opacity: 0 },
          0.125
        );

      mobileBannerTimeline.progress(1).progress(0);

      io.observe(mobileBannerTarget);
    }

    function tabs() {
      var tabHeading = document.querySelector('.tab-heading');
      var tabNavItems = document.querySelectorAll('.tab-nav li');
      var tabContent = document.querySelector('.tab-content');

      var timingOffset = tabHeading ? 0.25 : 0;

      tabsTimeline
        .from(
          tabHeading,
          { duration: 1, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0
        )
        .from(
          tabNavItems,
          {
            duration: 0.5,
            ease: 'power4.out',
            yPercent: 100,
            opacity: 0,
            stagger: 0.0625,
          },
          timingOffset
        )
        .from(
          tabContent,
          { duration: 0.5, ease: 'power4.out', y: 32, opacity: 0 },
          timingOffset
        );

      tabsTimeline.progress(1).progress(0);

      io.observe(tabsTarget);
    }

    function news(mql) {
      initVideos();
      var newsHeading = document.querySelector('.homepage--related-stories h2');
      var newsLink = document.querySelector('.homepage--related-stories > a');
      var newsItems = document.querySelectorAll(
        '.homepage--related-stories--items .article--teaser'
      );

      newsTimeline
        .from(
          newsHeading,
          { duration: 1, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0
        )
        .from(
          newsLink,
          { duration: 1, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0.0625
        )
        .from(
          newsItems,
          {
            duration: 1,
            ease: 'power4.out',
            y: 100,
            opacity: 0,
            stagger: 0.0625,
          },
          0.125
        );

      newsTimeline.progress(1).progress(0);

      io.observe(newsTarget);

      let $slider = $('.homepage--related-stories--items');
      $('.homepage--related-stories--items .article--teaser').wrap(
        '<div></div>'
      );
      if (mql.matches) {
        // Adds click event listener to tabs to control slides.
        let slickOptions = {
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          draggable: true,
          fade: false,
          arrows: false,
          adaptiveHeight: true,
        };
        // Initializes the slick slider.
        $slider.slick(slickOptions);
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }
    }

    function textImageCTA() {
      var body = document.querySelector('.text-image-video-cta--body');
      var image = document.querySelector('.text-image-video-cta--image');
      textImageCTATimeline
        .from(
          body,
          { duration: 1, ease: 'power4.out', yPercent: 25, opacity: 0 },
          0
        )
        .from(
          image,
          { duration: 1, ease: 'power4.out', yPercent: 25, opacity: 0 },
          0.125
        );

      textImageCTATimeline.progress(1).progress(0);

      io.observe(textImageCTATarget);
    }

    function intersectionHandler(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          //Icon Cards
          if (entry.target.className == 'icon-cards icon-cards--block') {
            ctaGridTimeline.play();
          }

          //Mobile Banner
          if (entry.target.className == 'mobile-banner') {
            mobileBannerTimeline.play();
          }

          //Tabs
          if (entry.target.className.indexOf('tabs') > -1) {
            tabsTimeline.play();
          }

          //News
          if (entry.target.className.indexOf('related-stories') > -1) {
            newsTimeline.play();
          }

          //Text Image CTA
          if (entry.target.className.indexOf('text-image-video-cta') > -1) {
            textImageCTATimeline.play();
          }

          observer.unobserve(entry.target);
        }
      });
    }

    function initVideos() {
      var videoModal = new VideoModal();
      var videos = document.querySelectorAll(
        '.article--teaser--video, .featured-article__video'
      );
      videoModal.init(videos);
    }

    // Initialize variables.
    let ctaGridTimeline = gsap.timeline({ paused: true });
    let mobileBannerTimeline = gsap.timeline({ paused: true });
    let tabsTimeline = gsap.timeline({ paused: true });
    let newsTimeline = gsap.timeline({ paused: true });
    let textImageCTATimeline = gsap.timeline({ paused: true });
    let io = new IntersectionObserver(intersectionHandler);
    let ctaGridTarget = document.querySelector('.icon-cards');
    let mobileBannerTarget = document.querySelector('.mobile-banner');
    let tabsTarget = document.querySelector('.tabs');
    let newsTarget = document.querySelector('.homepage--related-stories');
    let textImageCTATarget = document.querySelector('.text-image-video-cta');

    if (ctaGridTarget) {
      ctaGrid();
    }

    if (mobileBannerTarget) {
      mobileBanner();
    }

    if (tabsTarget) {
      tabs();
    }

    let mql = window.matchMedia('(max-width: 991px)');
    mql.addEventListener('change', news);

    if (newsTarget) {
      news(mql);
    }

    if (textImageCTATarget) {
      textImageCTA();
    }
  }
}

DrupalBehavior.register('rush_theme.pages', 'home', PageHome);
